<template>
  <div class = 'units-by-college'>
    <div class = 'unit-college' v-if='currentView !== "collegeView" && showCollege'>{{ (college.values[0].values[0].college || {}).name }}</div>
    <div class = 'unit-items'>
      <program
        v-for = 'program in college.values'
        :program = 'program'
        :key = 'program.key'
      >
      </program>
    </div>
  </div>
</template>
<script>
import Program from './program.vue'

export default {
  props: ['college'],
  components: {
    Program
  },

  computed: {
    showCollege() {
      return process.env.SHOW_COLLEGE
    },

    currentView() {
      return this.$store.getters.currentView
    }
  }
}
</script>



// WEBPACK FOOTER //
// college.vue?3ed8c834